import { useI18n } from 'builder/hooks/useI18n'
import { TRANSLATION } from '../../../constants'

type ResumeDistributionInfo = {
  badge?: string
  header: string
  subHeader: string
  actionText: string
}

type ResumeDistributionProps = {
  isLoading: boolean
  text: ResumeDistributionInfo
  status: 'initial' | 'progress' | 'completed'
}

export const useResumeDistributionConfig = (): ResumeDistributionProps => {
  const { i18n } = useI18n()
  const isCompleted = false
  const isLoading = false

  const getStatus = () => {
    if (isCompleted) return 'completed'
    return 'initial'
  }

  const getText = (): ResumeDistributionInfo => {
    const status = getStatus()
    if (status === 'completed') {
      return i18n.t(`${TRANSLATION}.completed`) as unknown as ResumeDistributionInfo
    }

    return {
      badge: i18n.t(`${TRANSLATION}.resume_distribution.${status}.badge`),
      header: i18n.t(`${TRANSLATION}.resume_distribution.${status}.header`),
      subHeader: i18n.t(`${TRANSLATION}.resume_distribution.${status}.subHeader`),
      actionText: i18n.t(`${TRANSLATION}.resume_distribution.${status}.actionText`, {
        count: 50,
      }),
    }
  }

  return {
    isLoading,
    text: getText(),
    status: getStatus(),
  }
}
